// extracted by mini-css-extract-plugin
export var checkboxInputRow = "w_sR";
export var checkboxInputColumn = "w_sS";
export var inputOptionRow = "w_sx";
export var inputOptionColumn = "w_sy";